import styled from 'styled-components';
import { Typ41, Typ35 } from 'dc/Typ';

export const Image = styled.img`
  width: 175px;
  height: 175px;
  margin-bottom: 32px;
`;

export const Title = styled(Typ41)`
  margin-bottom: 12px;
`;

export const Text = styled(Typ35)`
  line-height: 19px;
  margin-bottom: 76px;
  text-align: center;
  color: #263238;
`;
